"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserWidget = exports._UserWidget = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reduxBatchedActions = require("redux-batched-actions");

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _shapes = require("skybase-ui/skybase-core/shapes");

var _skybaseComponents = require("skybase-ui/skybase-components");

var _oauth = require("../../oauth");

var _tenantSwitch = require("./tenant-switch");

var _actions = require("../actions");

var _constants = require("../constants");

var _utils = require("../../utils");

var _actions2 = require("../../actions");

var _utils2 = require("../../users/utils");

var _actions3 = require("../../users/actions");

var _constants2 = require("../../users/constants");

var _usersI18n = require("../../users/users-i18n");

var _auth = require("../../auth");

var _oauthPermissions = require("../../oauth-permissions");

var _constants3 = require("./constants");

var _PropTypes$shape;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var LIST = _constants3.userWidgetSections.LIST,
    TENANT_SWITCH = _constants3.userWidgetSections.TENANT_SWITCH;
var kiconnectUsersWrite = _oauthPermissions.oAuthPermissions.kiconnectUsersWrite,
    kiconnectUsersRead = _oauthPermissions.oAuthPermissions.kiconnectUsersRead,
    kiconnectTenantsAdminister = _oauthPermissions.oAuthPermissions.kiconnectTenantsAdminister;

var _UserWidget = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(_UserWidget, _PureComponent);

  var _super = _createSuper(_UserWidget);

  function _UserWidget(props) {
    var _this;

    (0, _classCallCheck2.default)(this, _UserWidget);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOnViewProfileClick", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this$props, onRedirectTo, onFetchUser, id, onLoadUserToUpdate, onOpenViewUserModal, aclList, user;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, onRedirectTo = _this$props.onRedirectTo, onFetchUser = _this$props.onFetchUser, id = _this$props.id, onLoadUserToUpdate = _this$props.onLoadUserToUpdate, onOpenViewUserModal = _this$props.onOpenViewUserModal, aclList = _this$props.aclList;

              if (!aclList[kiconnectUsersRead]) {
                _context.next = 6;
                break;
              }

              _context.next = 4;
              return onFetchUser(id);

            case 4:
              user = _context.sent;

              if (aclList[kiconnectUsersWrite]) {
                // load to update
                onLoadUserToUpdate(user);
                onRedirectTo('users');
              } else {
                // load to view
                onOpenViewUserModal(user);
              }

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOnOpenChangePasswordModal", function () {
      var _this$props2 = _this.props,
          onOpenChangePasswordModal = _this$props2.onOpenChangePasswordModal,
          id = _this$props2.id;
      onOpenChangePasswordModal(id);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleGoToSwitchTenant", function (section) {
      setTimeout(function () {
        _this.setState({
          section: section
        });
      }, 1);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOnClose", function () {
      _this.setState({
        section: LIST
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getItems", function () {
      var _this$props3 = _this.props,
          onUserLogout = _this$props3.onUserLogout,
          _ = _this$props3.intl.formatMessage,
          aclList = _this$props3.aclList,
          authenticationProvider = _this$props3.authenticationProvider,
          hideViewProfile = _this$props3.hideViewProfile,
          hideChangePassword = _this$props3.hideChangePassword,
          hideSwitchTenant = _this$props3.hideSwitchTenant;
      var items = [];

      if (!hideViewProfile && aclList[kiconnectUsersRead] && _oauth.OAuth.isInNormalMode) {
        items.push({
          title: _(_usersI18n.messages.viewProfile),
          onClick: _this.handleOnViewProfileClick
        });
      } // We have to disable the change password for users registered through KistlerID, since it will require a separate page with additional configuration for changing password, unlinking the auth provider, etc.


      if (!hideChangePassword && !(0, _utils2.hasKistlerIDProvider)(authenticationProvider) && _oauth.OAuth.isInNormalMode) {
        items.push({
          title: _(_usersI18n.messages.changePassword),
          onClick: _this.handleOnOpenChangePasswordModal
        });
      }

      if (!hideSwitchTenant && aclList[kiconnectTenantsAdminister] && _oauth.OAuth.isInNormalMode) {
        items.push({
          title: _(_usersI18n.messages.switchTenant),
          onClick: function onClick() {
            return _this.handleGoToSwitchTenant(TENANT_SWITCH);
          },
          closeOnClick: false
        });
      }

      items.push({
        title: _(_usersI18n.messages.logout),
        onClick: onUserLogout
      });
      return items;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderTenantSwitch", function (close) {
      var aclList = _this.props.aclList;

      if (aclList[kiconnectTenantsAdminister]) {
        return /*#__PURE__*/_react.default.createElement(_tenantSwitch.TenantSwitch, {
          onBackClick: function onBackClick() {
            return _this.handleGoToSwitchTenant(LIST);
          },
          onClick: close
        });
      }

      return null;
    });
    _this.state = {
      section: LIST
    };
    return _this;
  }

  (0, _createClass2.default)(_UserWidget, [{
    key: "render",
    value: function render() {
      var section = this.state.section;
      var _this$props4 = this.props,
          isLoggedIn = _this$props4.isLoggedIn,
          name = _this$props4.name,
          email = _this$props4.email;
      return /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbUser, {
        items: this.getItems(),
        isLoggedIn: isLoggedIn,
        username: name || email,
        renderCustomContent: section === TENANT_SWITCH,
        customContentRenderer: this.renderTenantSwitch,
        onClose: this.handleOnClose
      });
    }
  }]);
  return _UserWidget;
}(_react.PureComponent);

exports._UserWidget = _UserWidget;
(0, _defineProperty2.default)(_UserWidget, "propTypes", {
  isLoggedIn: _propTypes.default.bool.isRequired,
  name: _propTypes.default.string,
  email: _propTypes.default.string,
  id: _propTypes.default.string,
  authenticationProvider: _propTypes.default.string,
  onUserLogout: _propTypes.default.func.isRequired,
  onFetchUser: _propTypes.default.func.isRequired,
  onRedirectTo: _propTypes.default.func,
  onOpenChangePasswordModal: _propTypes.default.func.isRequired,
  onOpenViewUserModal: _propTypes.default.func.isRequired,
  hideViewProfile: _propTypes.default.bool,
  hideChangePassword: _propTypes.default.bool,
  hideSwitchTenant: _propTypes.default.bool,
  intl: _shapes.intlShape.isRequired,
  // eslint-disable-line
  onLoadUserToUpdate: _propTypes.default.func.isRequired,
  aclList: _propTypes.default.shape((_PropTypes$shape = {}, (0, _defineProperty2.default)(_PropTypes$shape, kiconnectUsersWrite, _propTypes.default.bool), (0, _defineProperty2.default)(_PropTypes$shape, kiconnectUsersRead, _propTypes.default.bool), (0, _defineProperty2.default)(_PropTypes$shape, kiconnectTenantsAdminister, _propTypes.default.bool), _PropTypes$shape)).isRequired
});
(0, _defineProperty2.default)(_UserWidget, "defaultProps", {
  id: null,
  name: null,
  email: null,
  authenticationProvider: null,
  onRedirectTo: function onRedirectTo() {},
  hideViewProfile: false,
  hideChangePassword: false,
  hideSwitchTenant: false
});

var mapStateToProps = function mapStateToProps(state) {
  var _getOAuthState$AUTH_S = (0, _utils.getOAuthState)(state)[_constants.AUTH_STATE_KEY_NAME],
      isLoggedIn = _getOAuthState$AUTH_S.isLoggedIn,
      name = _getOAuthState$AUTH_S.name,
      email = _getOAuthState$AUTH_S.email,
      id = _getOAuthState$AUTH_S.id,
      authenticationProvider = _getOAuthState$AUTH_S.authenticationProvider;

  return {
    isLoggedIn: isLoggedIn,
    id: id,
    name: name,
    email: email,
    authenticationProvider: authenticationProvider
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var formatMessage = ownProps.intl.formatMessage;
  return {
    onUserLogout: function onUserLogout() {
      return dispatch((0, _actions.logOut)());
    },
    onFetchUser: function onFetchUser(id) {
      return dispatch((0, _utils2.fetchUser)(id, formatMessage));
    },
    onLoadUserToUpdate: function onLoadUserToUpdate(user) {
      return dispatch((0, _actions3.loadUserToUpdate)(user));
    },
    onOpenChangePasswordModal: function onOpenChangePasswordModal(id) {
      dispatch((0, _reduxBatchedActions.batchActions)([(0, _actions3.loadUserIdToChangePassword)(id), (0, _actions2.openOAuthModal)(_constants2.CHANGE_PASSWORD_MODAL_KEY)]));
    },
    onOpenViewUserModal: function onOpenViewUserModal(user) {
      dispatch((0, _reduxBatchedActions.batchActions)([(0, _actions3.loadUserToView)(user), (0, _actions2.openOAuthModal)(_constants2.VIEW_USER_MODAL_KEY)]));
    }
  };
};

var withAclListComponent = (0, _auth.withAclList)(_UserWidget, [kiconnectUsersWrite, kiconnectUsersRead, kiconnectTenantsAdminister]);
var UserWidget = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(withAclListComponent));
exports.UserWidget = UserWidget;
//# sourceMappingURL=user-widget.js.map